/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"DowngradeLoyaltyStatus":"DowngradeLoyaltyStatus_8def9","status":"status_Hcfu8"};